module.exports = __webpack_public_path__ + "static/media/Machop_gaussian2.3c9cf297.png";